import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthLayout } from "@/app/auth/AuthLayout";
import { waitlistMailtoUrl } from "@/lib/preview-mode";

/**
 * Default gate for `/login` and `/signup` while we're pre-launch.
 * Append `?preview=<anything>` to either URL to bypass.
 */
export function Waitlist() {
  return (
    <AuthLayout
      title="Join the waitlist"
      subtitle="MemKernel isn't open to the public yet. Drop us a line and we'll let you know the moment it ships."
      footer={
        <span>
          Already invited? Use the link we sent — it includes a preview
          token.
        </span>
      }
    >
      <div className="space-y-4">
        <Button asChild size="lg" className="h-12 w-full text-base">
          <a href={waitlistMailtoUrl()}>
            <Mail className="mr-2 h-5 w-5" />
            Notify me
          </a>
        </Button>
        <p className="text-center text-xs text-muted-foreground">
          Opens your email client. No form, no tracking.
        </p>
      </div>
    </AuthLayout>
  );
}
